/**
 * @generated SignedSource<<dc57e7d58bb20f6c3d5b6e6f73ce8989>>
 * @relayHash 89a51b1abf8ef83fe688e33de5c1fb32
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dd3c8315efd89765d5ffa60debbaad2d5530de01377f2a43448f8a191537e8bf

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterMediaConfigOperationType = "BANNER_UPLOAD" | "LOGO_UPLOAD" | "READ" | "%future added value";
export type hubHomeContentWrapperQuery$variables = {
  cloudId: string;
  hubAri: string;
  hubEditMode: boolean;
  operationType?: HelpCenterMediaConfigOperationType | null | undefined;
  pageAri: string;
};
export type hubHomeContentWrapperQuery$data = {
  readonly helpCenter: {
    readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference" | "hubHomeContent_AtlassianHubHome_HubInfo">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference">;
};
export type hubHomeContentWrapperQuery = {
  response: hubHomeContentWrapperQuery$data;
  variables: hubHomeContentWrapperQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubEditMode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "operationType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageAri"
},
v5 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "type"
},
v7 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "Variable",
  "name": "operationType",
  "variableName": "operationType"
},
v10 = [
  {
    "kind": "ScalarField",
    "name": "asapIssuer"
  },
  {
    "kind": "ScalarField",
    "name": "mediaCollectionName"
  },
  {
    "kind": "ScalarField",
    "name": "mediaToken"
  },
  {
    "kind": "ScalarField",
    "name": "mediaUrl"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "hubHomeContentWrapperQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "hubHomeContent_AtlassianHubHome_HubInfo"
          },
          {
            "kind": "FragmentSpread",
            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "hubHomeContentWrapperQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "helpCenterAri",
                "variableName": "hubAri"
              }
            ],
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "hoistedProjectKey"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "slug"
                  },
                  {
                    "concreteType": "HelpCenterName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  },
                  {
                    "alias": "allPages",
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "concreteType": "HelpCenterPageName",
                        "kind": "LinkedField",
                        "name": "name",
                        "plural": false,
                        "selections": (v7/*: any*/)
                      },
                      {
                        "concreteType": "HelpCenterPageDescription",
                        "kind": "LinkedField",
                        "name": "description",
                        "plural": false,
                        "selections": (v7/*: any*/)
                      }
                    ]
                  },
                  (v6/*: any*/),
                  {
                    "alias": "currentPage",
                    "args": [
                      {
                        "fields": [
                          {
                            "items": [
                              {
                                "kind": "Variable",
                                "name": "ids.0",
                                "variableName": "pageAri"
                              }
                            ],
                            "kind": "ListValue",
                            "name": "ids"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "filter"
                      }
                    ],
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "concreteType": "HelpCenterPageLayout",
                        "kind": "LinkedField",
                        "name": "pageLayout",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "HelpCenterLayoutAdf",
                            "kind": "LinkedField",
                            "name": "layoutAdf",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "HelpCenterLayoutAdfContentConnection",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "HelpCenterLayoutAdfContentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "HelpCenterLayoutAdfContent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "content"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fileId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "url"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v8/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "hubAri"
              },
              (v9/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v10/*: any*/)
          },
          {
            "alias": "pageMediaConfig",
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "pageAri"
              },
              (v9/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      },
      {
        "condition": "hubEditMode",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                  }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
              }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "cloudUrl"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "dd3c8315efd89765d5ffa60debbaad2d5530de01377f2a43448f8a191537e8bf",
    "metadata": {},
    "name": "hubHomeContentWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8578d4ce73f0c66e9882bf8dc1bdd2b5";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
